const styles = {
	wrapper: {
		cursor: 'pointer',
		'&.active': {
			cursor: 'default',
			'.gatsby-image-wrapper, .content': {
				opacity: 0.4,
			},
		},
	},
	imageWrapper: {
		position: 'relative',
		marginBottom: 15,
	},
	cart: {
		position: 'absolute',
		top: '5px',
		right: '5px',
		'&.isActive': {
			'> button': {
				opacity: 0,
				visibility: 'hidden',
				transform: 'scale(0.7)',
			},
			div: {
				opacity: 1,
				visibility: 'visible',
				transform: 'scale(1)',
			},
		},
		'button.active': {
			color: 'white',
			fontSize: 0,
			fontWeight: 700,
			backgroundColor: 'primary',
			':hover': {
				backgroundColor: 'primary',
			},
		},
	},
	cartBtn: {
		opacity: 1,
		visibility: 'visible',
		transform: 'scale(1)',
		marginLeft: 'auto',
		transition: 'all 0.2s ease',
		'&:disabled': {
			opacity: 0.6,
			cursor: 'not-allowed',
		},
	},
	cartCounter: {
		transform: 'scale(0.7)',
		position: 'absolute',
		top: 0,
		right: 0,
		opacity: 0,
		visibility: 'hidden',
		display: 'flex',
		alignItems: 'center',
		minWidth: 140,
		minHeight: 40,
		borderRadius: 6,
		overflow: 'hidden',
		backgroundColor: 'primary',
		boxShadow: '0 6px 12px rgba(0, 0, 0, 0.16)',
		transition: 'all 0.2s ease',
		'&.disabled': {
			'button, div': {
				opacity: 0.6,
				cursor: 'not-allowed',
			},
		},
		div: {
			width: 50,
			color: 'white',
			textAlign: 'center',
			fontSize: 0,
			fontWeight: 700,
			paddingLeft: 0,
			paddingRight: 0,
		},
		button: {
			padding: 0,
			minWidth: 45,
			minHeight: 40,
			svg: {
				width: 24,
				marginLeft: 0,
			},
		},
	},
	price: {
		color: 'primary',
		fontWeight: 700,
	},
	prevPrice: {
		color: 'darkgray',
		fontSize: 0,
		marginLeft: 11,
	},
	title: {
		fontSize: 0,
		fontWeight: 400,
		lineHeight: 2,
		fontFamily: 'body',
		marginTop: 10,
	},
};

export default styles;
